import instance from "../utils/network";

export interface MarketingProductDto {
  id: number;
  name: string;
  price: number;
  seed: number;
  count: string;
  createdAt: string;
  updatedAt: string;
  type: MarketingProductType;
}

export interface MarketingRequest {
  userId: number;
  productId: number;
  count: number;
  memo: string;
}

export enum MarketingProductType {
  QUANTITY = "QUANTITY", // 수량형
  PERIOD = "PERIOD", // 기간형
}

export function getMarketingProducts(): Promise<MarketingProductDto[]> {
  return instance.get("/nest/marketing/product");
}

export function requestMarketing(
  request: MarketingRequest
): Promise<{ code: number; message: string }> {
  return instance.post("/nest/marketing/request", request);
}
